<template>
    <div>
        <vs-row>
            <vs-col sm="12" lg="8">
                <h4 class="p-2">Prospectos</h4>
            </vs-col>
            <vs-col sm="12" lg="4" v-if="permisos">
                <vs-button
                    success
                    class="ml-auto"
                    flat
                    @click="activeCrear =! activeCrear"
                >
                    <i class="fas fa-plus mr-2"></i> Crear registro
                </vs-button>
            </vs-col>
        </vs-row>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="cicloEscolar" class="labelInput">
                        Ciclo Escolar <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="grupo" class="labelInput">
                        Grupo
                    </label>
                    <vs-select filter :loading="loadingGrupo" class="aqui pt-0" id="grupo" placeholder="Seleccionar Grupo" :key="grupoId" v-model="grupo" :disabled="!grupos.length || ofertaAcademica != ''" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('grupo')">
                            Requerido
                        </template>
                        <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                    <div v-if="grupo !== ''" @click="grupo = ''" class="tache">
                        <i class="far fa-times-circle"></i>
                    </div>
                </form>
            </vs-col>
            <vs-col sm="12" lg="4">
                <div class="d-flex " style="justify-content: space-between;">
                    <label for="ofertaAcademica" class="labelInput">
                        Oferta académica
                    </label>
                    <div class="d-flex" v-if="ofertasAcademicas[0] && grupo == ''">
                        <div> 
                            <vs-tooltip>
                                <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(ofertasAcademicas, 'ofertasAcademicas')"></i>
                                <template #tooltip>
                                    Seleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        <div class="labelInput">
                            <vs-tooltip>
                                <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('ofertasAcademicas')"></i>
                                <template #tooltip>
                                    Deseleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        
                    </div>
                </div>
                <vs-select filter multiple collapse-chips :loading="loadingOferta" class="aqui pt-0" id="ofertaAcademica" placeholder="Seleccionar Oferta académica" :key="ofertaId" v-model="ofertaAcademica" :disabled="!ofertasAcademicas.length || grupo != ''" autocomplete="off">
                    <template #message-danger v-if="errorFields.includes('ofertaAcademica')">
                        Requerido
                    </template>
                    <vs-option v-for="option in ofertasAcademicas" :key="option.id"  :label="option.text" :value="option.id">
                        {{option.text}}
                    </vs-option>
                </vs-select>
            </vs-col>
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="estatus" class="labelInput">
                        Estatus
                    </label>
                    <vs-select :loading="loadingEstatus" filter class="aqui pt-0" id="estatus" placeholder="Seleccionar Estatus" :key="estatuId" v-model="estatu" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('estatu')">
                            Requerido
                        </template>
                        <vs-option v-for="option in estatus" :key="option.id"  :label="option.status" :value="option.id">
                            {{option.status}}
                        </vs-option>
                    </vs-select>
                    <div v-if="estatu !== ''" @click="estatu = ''" class="tache">
                        <i class="far fa-times-circle"></i>
                    </div>
                </form>
            </vs-col>
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="estatus" class="labelInput">
                        Origen
                    </label>
                    <vs-select filter class="aqui pt-0" id="estatus" placeholder="Seleccionar origen" v-model="origen">
                        <vs-option label="Módulo prospectos" value="modulo_prospectos">
                            Módulo prospectos
                        </vs-option>
                        <vs-option label="Landing Marketing" value="landing_marketing">
                            Landing Marketing
                        </vs-option>
                        <vs-option label="Migración interna" value="migracion_interna">
                            Migración interna
                        </vs-option>
                    </vs-select>
                    <div v-if="origen !== ''" @click="origen = ''" class="tache">
                        <i class="far fa-times-circle"></i>
                    </div>
                </form>
            </vs-col>
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="nombre" class="labelInput">
                        Nombre
                    </label>
                    <vs-input class="pt-0" id="nombre" v-model="nombre" placeholder="Nombre" />
                </form>
            </vs-col>
            <vs-col sm="12" lg="12">
                <vs-button
                class="ml-auto"
                    @click="getProspectos(), ejecutar += 1"
                >
                    Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <tabla-prospectos :parametros="parametros" :ejecutar="ejecutar" :institucionSelect="institucion" :instituciones="instituciones" :ciclo="cicloEscolar" :permisos="permisos" @refreshTable="getProspectos"></tabla-prospectos>
        <crear v-model="activeCrear" :institucionSelect="institucion" :instituciones="instituciones" :ciclo="cicloEscolar" :escuelas="escuelas" :escuelasId="escuelasId" @refreshTable="getProspectosCrear"></crear>
    </div>
</template>

<script>
import catalogos from '../../../../api/requests/catalogos.js'
import admisiones from '../../../../api/requests/admisiones.js'
import TablaProspectos from './tabla-prospectos.vue'
import crear from './modales/crear.vue'
export default {
    data(){
        return{
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            loadingCiclo: false,
            ofertaAcademica: '',
            ofertasAcademicas: [],
            ofertaId: (new Date()).getTime(),
            ofert: '',
            loadingOferta: false,
            grupo: '',
            grupos: [],
            grupoId: (new Date()).getTime(),
            loadingGrupo: false,
            estatu: '',
            estatus: [],
            estatuId: (new Date()).getTime(),
            loadingEstatus: false,
            nombre: '',
            parametros: [],
            ejecutar: 0,
            errorFields: [],
            activeCrear: false,
            escuelas: [],
            escuelasId: (new Date()).getTime(),
            origen: '',
            permisos: false
        }
    },
    components:{
        TablaProspectos,
        crear
    },
    created(){
        this.getInstituciones()
        this.getEstatusAlumno()
        this.getPermisos()
    },
    methods:{
        async getPermisos () {
            try {
                const params = {
                    "seccion" : 'admisiones'
                    }
                const { data: perm } = await catalogos.getPermisosSeccion(params)
                const permi = perm.permisos
                if(permi.includes('bloquear-crear-modificar-prospectos')){
                    this.permisos = false
                }else{
                    this.permisos = true
                }
            } catch (error) {
                console.log(error)
            }            
        },
        selectAll(seleccion, tipo){
              let arr = []
            seleccion.forEach(i => {
              arr.push(i.id)
            })
            if(tipo == 'ofertasAcademicas'){
                this.ofertaAcademica = arr
            }
        },
        deseleccionarAll(tipo){
            if(tipo == 'ofertasAcademicas'){
                this.ofertaAcademica = ''
            }
        },
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await admisiones.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch{

            }
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.loadingCiclo = true
                const { data: response } = await admisiones.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
                this.loadingCiclo = false
            }
        },
        async getOfertaAcademica() {
            if(this.cicloEscolar){
                this.loadingOferta = true
                const { data: response } = await admisiones.getOfertaAcademica(this.institucion, this.cicloEscolar)
                this.ofertasAcademicas = this.getEliminarNameKey(response)
                this.ofertaId = (new Date()).getTime()
                this.loadingOferta = false
            }
        },
        async getGrupo() {
            if(this.cicloEscolar){
                this.loadingGrupo = true
                const params = {
                    ciclo_escolar_id: this.cicloEscolar
                }
                const { data: response } = await admisiones.getGrupo(this.institucion, params)
                this.grupos = this.getEliminarNameKey(response)
                this.grupoId = (new Date()).getTime()
                this.loadingGrupo = false
            }
        },
        async getEstatusAlumno(){
            try{
                this.loadingEstatus = true
                const {data: response} = await admisiones.getEstatusAlumno()
                this.estatus = response
                this.estatuId = (new Date()).getTime()
                this.loadingEstatus = false
            }catch(error){
                console.error(error)
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
        sanityForm () {
            this.errorFields = []
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if(this.ofertaAcademica == ''){
                if (!this.grupo) {
                    this.errorFields.push('grupo')
                }
            }
            if(this.grupo == ''){
                if (!this.ofertaAcademica) {
                    this.errorFields.push('ofertaAcademica')
                }
            }
            if (!this.errorFields.length){
                const params = {
                    cicloEscolar: this.cicloEscolar,
                    institucion: this.institucion,
                    oferta: this.ofertaAcademica,
                    grupo: this.grupo,
                    estatus: this.estatu,
                    nombre: this.nombre,
                    origen: this.origen
                }
                if(this.ofertaAcademica[0] == ''){
                    const eliminarOfertaAcademica = this.ofertaAcademica.shift()
                    params.oferta = this.ofertaAcademica
                }else{
                    params.oferta = this.ofertaAcademica
                }
                return params
            } else {
                return null
            }
        },
        getProspectos(){
            this.parametros = this.sanityForm()
        },
        getProspectosCrear(institucion, ciclo, oferta){
            this.institucion = institucion
            this.cicloEscolar = ciclo
            this.ofert = oferta
            this.ofertaAcademica = oferta
            this.errorFields = []
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.ofertaAcademica) {
                this.errorFields.push('ofertaAcademica')
            }
            if (!this.errorFields.length){
                this.ofertaAcademica = ''
                this.grupo = ''
                this.estatu = ''
                this.nombre = ''
                const params = {
                    cicloEscolar: ciclo,
                    institucion: institucion,
                    oferta: oferta,
                    grupo: this.grupo,
                    estatus: this.estatu,
                    nombre: this.nombre
                }
                
                if(this.origen){
                    params.origen = this.origen
                }
                this.parametros = params
                this.ejecutar += 1
            } else {
                return null
            }
        },
        getOferta(){
            if(this.ofert != ''){
                this.ofertaAcademica = this.ofert
            }
        }
    },
    watch:{
        institucion(){
            this.estatu = ''
            this.nombre = ''
            this.grupo = ''
            this.ofertaAcademica = ''
            this.ofertasAcademicas = []
            this.grupos = []
            this.cicloEscolar = ''
            this.getCicloEscolar()
        },
        cicloEscolar(){
            this.ofertaAcademica = ''
            this.grupo = ''
            this.getOfertaAcademica()
            this.getGrupo()
            this.getOferta()
        }
    }
}
</script>

<style lang="scss" scoped>

    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>